import Storage from '@/support/Storage';
export class Token {
    static title() {
        return 'token';
    }
    static set(accessToken) {
        Storage.set(Token.title(), accessToken);
    }
    static get() {
        return Storage.get('token') || '';
    }
    static delete() {
        Storage.delete('token');
    }
}
